const getStorage = type => {
  try {
    return window[type]
  } catch (_) {
    return null
  }
}

export const readStorage = (type, key, fallback = '') => {
  try {
    return getStorage(type)?.getItem(key) ?? fallback
  } catch (_) {
    return fallback
  }
}

export const writeStorage = (type, key, value) => {
  try {
    getStorage(type)?.setItem(key, value)
    return true
  } catch (_) {
    return false
  }
}

export const removeStorage = (type, key) => {
  try {
    getStorage(type)?.removeItem(key)
    return true
  } catch (_) {
    return false
  }
}
